// extracted by mini-css-extract-plugin
export default {"inputControl":"Select_inputControl__VB9Rb","label":"Select_label__xb4MK","requiredMark":"Select_requiredMark__LNZ+z","inputField":"Select_inputField__KmD+r"};